module.exports = __webpack_public_path__ + "img/1.fc215240.png";